import { Skeleton, Grid } from '@mui/material';

function SparkSearchResultSkeleton() {
  return (
    <Grid
      item
      container
      sx={{
        bgcolor: 'white',
        display: 'flex',
        border: '1px solid #EEEEEE',
      }}
      gap={2}
      paddingX={2}
    >
      <Grid display='flex' gap={1} alignItems='center'>
        <Skeleton variant='rounded' width={50} height={50} />
      </Grid>
      <Grid
        item
        flex={1}
        container
        flexDirection='column'
        justifyContent='center'
      >
        <Skeleton variant='text' width='100%' height={35} />
        <Skeleton variant='text' width='100%' height={35} />
      </Grid>
      <Grid item alignItems='center'>
        <Skeleton variant='text' width={100} height={80} />
      </Grid>
    </Grid>
  );
}

export default SparkSearchResultSkeleton;
